import {Helmet} from "react-helmet";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { useHeading } from '../HeadingContext';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Reveal } from "../Reveal";


const ExperienceCard = ({ experience }: { experience: any }) => {
    return (
      <VerticalTimelineElement
        contentStyle={{
          background: "#3A506B",
          color: "#FFFFFF",
        }}
        contentArrowStyle={{ borderRight: "7px solid #3A506B" }}
        date={experience.date}
        iconStyle={{ background: experience.iconBgl }}
        icon={
          <div className='flex justify-center items-center w-full h-full'>
            <img
              src={experience.icon}
              alt={experience.company_name}
              className='w-[100%] h-[100%] rounded-full'
            />
          </div>
        }
      >
        <div>
          <h3 className='text-white big-size font-bold'>{experience.title}</h3>
          <p
            className='text-white medium-size font-semibold'
            style={{ margin: 0 }}
          >
            {experience.company_name}
          </p>
        </div>
  
        <ul className='mt-5 list-disc ml-5 space-y-2'>
          {experience.points.map((point: string, index: number) => (
            <li
              key={`experience-point-${index}`}
              className='text-white-100 small-size pl-1 tracking-wider'
            >
              {point}
            </li>
          ))}
        </ul>
        <h3 className="normal-size font-semibold pt-6 pb-2">Tools Used: </h3>
        <h4 className="small-size">{experience.tools}</h4>
      </VerticalTimelineElement>
    );
  };

const Clients = () => {
    const { HeadingHeight, MinHeight } = useHeading()!;
    // const bg_1 = "/bg_1.jpg";
    const firstLogo = "/ScotiabankLogo.png";
    const secondLogo = "/VirtruLogo.png";
    const thirdLogo = "/TheStarsGroupLogo.png";

    const experiences = [
        {
          title: "ScotiaBank",
        //   company_name: "ScotiaBank",
          icon: firstLogo,
          iconBg: "#FFFFFF",
        //   date: "March 2020 - April 2021",
          points: [
            "Developed and implemented a custom automation testing framework from the ground up.",
            "Managed regression testing.",
            "Generated the extent automation test report.",
          ],
          tools: "IntelliJ IDEA, Java, TestNG, Git, POM"
        },
        {
          title: "Virtru",
        //   company_name: "Virtru",
          icon: secondLogo,
          iconBg: "#FFFFFF",
        //   date: "Jan 2021 - Feb 2022",
          points: [
            "Developed and maintained an automation test framework capable of communicating with 3rd party services (e.g. BuildKite, GitHub).",
            "Built and extended the automation test framework for Web/Mobile Hybrid/Mobile App testing on iOS and Android.",
          ],
          tools: "Appium, AWS services, BuildKite, Docker with API integration, GitHub, JIRA, SauceLabs, Selenium, Slack, SonarCloud, TestRail"
        },
        {
          title: "The Stars Group",
        //   company_name: "The Stars Group",
          icon: thirdLogo,
          iconBg: "#FFFFFF",
        //   date: "Jan 2022 - Jan 2023",
          points: [
            "Created Jenkins daily smoke test pipeline and weekly regression test pipeline, while integrating Allure reports.",
            "Established a python automation test framework based on UI testing for the MarTechEndpoint Restart Checklist Test.",
          ],
          tools: "Pytest, Python API, DB2, Jenkins, Allure, Grafana, TestNG with BDD, Github, JIRA, Selenium, Slack, TestRail"
        },
      ];
    

    return ( 
        <div className="clients bg-secondary" style={{ minHeight: MinHeight }}>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Early Learning Kingdom - Clients</title>
                <link rel="canonical" href="http://earlylearningkingdom.com/clients" />
                <meta name="description" content="Clients Page" />
            </Helmet>
            <Reveal>
                <div className="text-white title px-[8vw] pt-[16vh] pb-[0vh]">Our Clients</div>
            </Reveal>
            <div>
                <div className='mt-20 flex flex-col'>
                <VerticalTimeline>
                {experiences.map((experience, index) => (
                    <ExperienceCard
                    key={`experience-${index}`}
                    experience={experience}
                    />
                ))}
                </VerticalTimeline>
            </div>
        </div>
        <div className="h-[24vh]"></div>
            <div id="contact-header-holder" className="absolute bottom-0 w-full"
                style={{ height: HeadingHeight }}>
            </div>
        </div>
     );
}
 
export default Clients;